import { ButtonHTMLAttributes } from 'react';
import clsx from 'clsx';
import './ui.css';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'ghost' | 'danger';
  size?: 'sm' | 'md';
}

export function Button({ variant = 'secondary', size = 'md', className, ...rest }: Props) {
  return <button className={clsx('btn', `btn--${variant}`, `btn--${size}`, className)} {...rest} />;
}
